import type { MouseEvent } from 'react';

import BpkButton, { BUTTON_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';
import { BpkSpinner, SPINNER_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-spinner';

import ProfilePicture from './ProfilePicture';

import STYLES from './LoginButton.module.scss';

type Props = {
  isLoggedIn?: boolean;
  profilePictureUrl: string | null;
  onProfilePictureError: () => void;
  onLoginClick: (e: MouseEvent<HTMLButtonElement>) => void;
  loginText: string;
  accountText: string;
};

const DesktopLoginButton = ({
  accountText,
  isLoggedIn,
  loginText,
  onLoginClick,
  onProfilePictureError,
  profilePictureUrl,
}: Props) => {
  if (isLoggedIn === undefined) {
    return (
      <BpkSpinner className={STYLES.AccountSpinner} type={SPINNER_TYPES.primary} alignToButton />
    );
  }
  if (isLoggedIn) {
    return (
      <ProfilePicture
        profilePictureUrl={profilePictureUrl}
        onProfilePictureError={onProfilePictureError}
        onLoginClick={onLoginClick}
        accountText={accountText}
      />
    );
  }
  return (
    <BpkButton
      fullWidth
      onClick={onLoginClick}
      label={loginText}
      type={BUTTON_TYPES.secondary}
      aria-label={loginText}
    >
      <span id="authentication-link" className="login">
        {loginText}
      </span>
    </BpkButton>
  );
};

export default DesktopLoginButton;
